import React from 'react';

export const SuccessSVG = () => (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="16"
            cy="16"
            r="15"
            fill="#E5F6F6"
            stroke="#1FA5A4"
            strokeWidth="2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.70711 15.2929C9.31658 14.9024 8.68342 14.9024 8.29289 15.2929C7.90237 15.6834 7.90237 16.3166 8.29289 16.7071L13.2929 21.7071C13.698 22.1122 14.36 22.0948 14.7433 21.669L23.7433 11.669C24.1128 11.2585 24.0795 10.6262 23.669 10.2567C23.2585 9.88726 22.6262 9.92053 22.2567 10.331L13.9618 19.5476L9.70711 15.2929Z"
            fill="#1FA5A4"
        />
    </svg>
);

SuccessSVG.displayName = 'SuccessSVG';
